<template>
	<span id="itWrapper">
		<span
			@mouseenter="showTooltip"
			@mouseleave="hideTooltip"
			id="itInfoCircle"
			ref="infoCircle"
		>&nbsp;</span>
		<span id="itTooltip" v-if="tooltip.visible" :style="{ 'left': tooltip.left, 'top': tooltip.top }">
			<slot></slot>
		</span>
	</span>
</template>

<script>
import { setTimeout, clearTimeout } from "timers";

export default {
	data() {
		return {
			tooltip: {
				visible: false,
				top: "auto",
				left: "auto"
			},
			timeout: null,
			delay: 200
		};
	},
	methods: {
		showTooltip() {
			this.positionTooltip();
			this.timeout = setTimeout(() => {
				this.tooltip.visible = true;
			}, this.delay);
		},
		hideTooltip() {
			clearTimeout(this.timeout);
			this.tooltip.visible = false;
		},
		positionTooltip() {
			const rect = this.$refs.infoCircle.getBoundingClientRect();

			this.tooltip.left = rect.left + rect.width + 16 + "px";
			this.tooltip.top = rect.top - rect.height / 4 + "px";
		}
	},
	mounted() {
		this.positionTooltip();
	}
};
</script>

<style>
#itWrapper {
	margin: 0 0 0 8px;
}

#itInfoCircle {
	position: relative;
	display: inline-block;
	text-align: center;
	opacity: 0.87;
	width: 20px;
	height: 20px;
	background: no-repeat center
		url("../../assets/img/info-tooltip/round-info-24px.svg");
	cursor: help;
}

#itInfoCircle:hover {
	opacity: 1;
}

#itTooltip {
	position: fixed;
	background-color: white;
	padding: 4px 8px;
	border: 1px solid #e0e0e0;
	box-shadow: 0px 16px 16px rgba(35, 38, 43, 0.24);
	border-radius: 4px;
	z-index: 999;
}
</style>
